export interface RecentItem {
  id: string;
  type: "vendor" | "venue";
  name: string;
  city: string;
  category?: string;
  venueType?: string;
  addedAt: number;
}

const KEY = "bms_recently_viewed";
const MAX = 4;

export function getRecentlyViewed(): RecentItem[] {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as RecentItem[]) : [];
  } catch {
    return [];
  }
}

export function trackRecentView(item: Omit<RecentItem, "id" | "addedAt">): void {
  try {
    const id = `${item.type}:${item.name.toLowerCase().trim()}:${item.city.toLowerCase().trim()}`;
    const prev = getRecentlyViewed().filter(i => i.id !== id);
    const updated = [{ ...item, id, addedAt: Date.now() }, ...prev].slice(0, MAX);
    localStorage.setItem(KEY, JSON.stringify(updated));
  } catch {}
}
